import { FC, useEffect } from "react";
import cl from "classnames";
import styles from "./Pagination.module.scss";
import { ArrowIcon } from "../../icons";
import { CircleButton } from "../Buttons";

interface IPagination {
  currentPage: number;
  maxPages: number;
  setNext: () => void;
  setPrev: () => void;
  jumpToPage: (arg: number) => void;
  className?: string;
}
const getPagesArr = (pagesAmount: number) => {
  const result = [];
  for (let i = 1; i <= pagesAmount; i++) {
    result.push(i);
  }
  return result;
};
export const Pagination: FC<IPagination> = ({
  currentPage,
  jumpToPage,
  maxPages,
  setNext,
  setPrev,
  className,
}) => {
  const pagesArr = getPagesArr(maxPages);
  const showFirstDots = currentPage > 4;
  const showLastDots = currentPage + 3 < maxPages;

  useEffect(() => {
    if (currentPage > maxPages) {
      jumpToPage(maxPages);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, maxPages]);
  return (
    <div className={cl(styles.pagination, className)}>
      <CircleButton
        as={"button"}
        content={<ArrowIcon />}
        styleType={"secondary"}
        theme={"dark"}
        className={styles.pagination__arrow}
        onClick={setPrev}
        disabled={currentPage === 1}
        name="select previous page"
      />
      {currentPage > 3 && (
        <button
          className={cl(
            styles.pagination__button,
            currentPage === 1 && styles["pagination__button--active"],
          )}
          onClick={() => jumpToPage(1)}
        >
          1
        </button>
      )}

      {showFirstDots && <DotsButton />}
      {pagesArr.slice(Math.max(0, currentPage - 3), currentPage + 2).map((page) => {
        const isActive = page === currentPage;
        return (
          <button
            key={page}
            className={cl(
              styles.pagination__button,
              isActive && styles["pagination__button--active"],
            )}
            onClick={() => jumpToPage(page)}
          >
            {page}
          </button>
        );
      })}
      {showLastDots && <DotsButton />}
      {maxPages - currentPage > 2 && (
        <button
          className={cl(
            styles.pagination__button,
            currentPage === maxPages && styles["pagination__button--active"],
          )}
          onClick={() => jumpToPage(maxPages)}
        >
          {maxPages}
        </button>
      )}
      <CircleButton
        name="select next page"
        as={"button"}
        content={<ArrowIcon isRight />}
        styleType={"secondary"}
        theme={"dark"}
        className={styles.pagination__arrow}
        onClick={setNext}
        disabled={currentPage === maxPages}
      />
    </div>
  );
};

const DotsButton = () => {
  return (
    <button className={cl(styles.pagination__arrow, styles.pagination__dots)}>...</button>
  );
};
